import { InjectionToken } from "@angular/core";

export const GoogleClientIdToken = new InjectionToken("GoogleClientIdToken");
